import {
  getUserStorageList,
  setUserStorageItems,
  userStorageItems,
} from 'api/userStorage';
import { LocalStorage, LocalStorageKeys } from 'helpers/localStorage';

// one item per lottery, so a win popup is shown once across devices
const SEEN_WIN_PREFIX = 'lottery_win_';

const getLocalStorage = (userId: number) =>
  new LocalStorage<number[], number[]>(
    `${LocalStorageKeys.LotterySeenWins}-${userId}`,
    []
  );

export const getSeenWinIds = async (
  userId: number,
  isServerStorageEnabled: boolean
): Promise<number[]> => {
  const localIds = getLocalStorage(userId).get();

  if (!isServerStorageEnabled) return localIds;

  try {
    const { data } = await userStorageItems();

    const serverIds = getUserStorageList(data)
      .filter(({ identifier }) => identifier.startsWith(SEEN_WIN_PREFIX))
      .map(({ identifier }) =>
        Number(identifier.slice(SEEN_WIN_PREFIX.length))
      );

    return Array.from(new Set([...localIds, ...serverIds]));
  } catch {
    return localIds;
  }
};

export const saveSeenWinId = async (
  userId: number,
  isServerStorageEnabled: boolean,
  lotteryId: number
): Promise<void> => {
  try {
    const storage = getLocalStorage(userId);

    if (!storage.get().includes(lotteryId)) storage.push([lotteryId]);
  } catch {}

  if (!isServerStorageEnabled) return;

  try {
    await setUserStorageItems([
      {
        identifier: `${SEEN_WIN_PREFIX}${lotteryId}`,
        info: { seen_at: new Date().toISOString() },
      },
    ]);
  } catch {}
};
